import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getVehiclesInformation = (filters, token, persistResponse = false) => {
    /*if (filters.request_type === 'brand') {
        return axios({
            method: 'get',
            url: `https://www.chileautos.cl/autos/Search/Makes?recordType=${filters.vehicle_type}`,
            headers: {
                ...headers,
                persistResponse,
                notCachedResponse: !persistResponse
            }
        });
    }
    else if (filters.request_type === 'model') {
        return axios({
            method: 'get',
            url: `https://www.chileautos.cl/autos/Search/Models?recordType=${filters.vehicle_type}&make=${filters.brand}`,
            headers: {
                ...headers,
                persistResponse,
                notCachedResponse: !persistResponse
            }
        });
    }*/
    return axios({
        method: 'get',
        url: `${api}/types?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            persistResponse,
            notCachedResponse: !persistResponse
        }
    });
};

export const getVehicles = (filters, token) =>
    axios({
        method: 'get',
        url: `${api}/vehicles?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    });
